// Données complètes des territoires du Togo avec coordonnées et limites
export const togoTerritories = {
  Maritime: {
    center: [6.1319, 1.2228],
    zoom: 9,
    bounds: [
      [5.5, 0.5],
      [6.8, 1.8],
    ],
    prefectures: {
      Golfe: {
        center: [6.1319, 1.2228],
        zoom: 11,
        bounds: [
          [6.0, 1.0],
          [6.3, 1.4],
        ],
        communes: {
          "Lomé Commune": {
            center: [6.1319, 1.2228],
            zoom: 13,
            bounds: [
              [6.1, 1.1],
              [6.2, 1.3],
            ],
          },
          "Aflao-Sagbado": {
            center: [6.15, 1.18],
            zoom: 13,
            bounds: [
              [6.13, 1.15],
              [6.17, 1.21],
            ],
          },
          "Aflao-Gakli": {
            center: [6.12, 1.25],
            zoom: 13,
            bounds: [
              [6.1, 1.22],
              [6.14, 1.28],
            ],
          },
        },
      },
      Avé: {
        center: [6.45, 1.15],
        zoom: 11,
        bounds: [
          [6.3, 1.0],
          [6.6, 1.3],
        ],
        communes: {
          Kévé: {
            center: [6.45, 1.15],
            zoom: 13,
            bounds: [
              [6.42, 1.12],
              [6.48, 1.18],
            ],
          },
          Dzogbégan: {
            center: [6.42, 1.18],
            zoom: 13,
            bounds: [
              [6.39, 1.15],
              [6.45, 1.21],
            ],
          },
        },
      },
      Lacs: {
        center: [6.23, 1.59],
        zoom: 11,
        bounds: [
          [6.1, 1.4],
          [6.4, 1.8],
        ],
        communes: {
          Aného: {
            center: [6.23, 1.59],
            zoom: 13,
            bounds: [
              [6.2, 1.56],
              [6.26, 1.62],
            ],
          },
          Agbodrafo: {
            center: [6.19, 1.52],
            zoom: 13,
            bounds: [
              [6.16, 1.49],
              [6.22, 1.55],
            ],
          },
        },
      },
      Vo: {
        center: [6.35, 1.05],
        zoom: 11,
        bounds: [
          [6.2, 0.9],
          [6.5, 1.2],
        ],
        communes: {
          Vogan: {
            center: [6.35, 1.05],
            zoom: 13,
            bounds: [
              [6.32, 1.02],
              [6.38, 1.08],
            ],
          },
          Afagnan: {
            center: [6.38, 1.02],
            zoom: 13,
            bounds: [
              [6.35, 0.99],
              [6.41, 1.05],
            ],
          },
        },
      },
      Yoto: {
        center: [6.55, 1.18],
        zoom: 11,
        bounds: [
          [6.4, 1.0],
          [6.7, 1.4],
        ],
        communes: {
          Tabligbo: {
            center: [6.55, 1.18],
            zoom: 13,
            bounds: [
              [6.52, 1.15],
              [6.58, 1.21],
            ],
          },
          Kpomé: {
            center: [6.52, 1.21],
            zoom: 13,
            bounds: [
              [6.49, 1.18],
              [6.55, 1.24],
            ],
          },
        },
      },
      Zio: {
        center: [6.44, 0.9],
        zoom: 11,
        bounds: [
          [6.3, 0.7],
          [6.6, 1.1],
        ],
        communes: {
          Tsévié: {
            center: [6.44, 0.9],
            zoom: 13,
            bounds: [
              [6.41, 0.87],
              [6.47, 0.93],
            ],
          },
          "Kpélé-Akata": {
            center: [6.47, 0.87],
            zoom: 13,
            bounds: [
              [6.44, 0.84],
              [6.5, 0.9],
            ],
          },
        },
      },
    },
  },

  Plateaux: {
    center: [7.0, 0.9],
    zoom: 8,
    bounds: [
      [6.5, 0.3],
      [7.8, 1.5],
    ],
    prefectures: {
      Agou: {
        center: [6.85, 0.78],
        zoom: 11,
        bounds: [
          [6.7, 0.6],
          [7.0, 1.0],
        ],
        communes: {
          "Agou 1": {
            center: [6.85, 0.78],
            zoom: 13,
            bounds: [
              [6.82, 0.75],
              [6.88, 0.81],
            ],
          },
          "Agou 2": {
            center: [6.88, 0.81],
            zoom: 13,
            bounds: [
              [6.85, 0.78],
              [6.91, 0.84],
            ],
          },
        },
      },
      Kloto: {
        center: [6.9, 0.63],
        zoom: 11,
        bounds: [
          [6.7, 0.4],
          [7.1, 0.9],
        ],
        communes: {
          Kpalimé: {
            center: [6.9, 0.63],
            zoom: 13,
            bounds: [
              [6.87, 0.6],
              [6.93, 0.66],
            ],
          },
          "Kpélé-Élé": {
            center: [6.93, 0.66],
            zoom: 13,
            bounds: [
              [6.9, 0.63],
              [6.96, 0.69],
            ],
          },
        },
      },
      Ogou: {
        center: [7.15, 1.08],
        zoom: 11,
        bounds: [
          [7.0, 0.9],
          [7.3, 1.3],
        ],
        communes: {
          Atakpamé: {
            center: [7.53, 1.13],
            zoom: 13,
            bounds: [
              [7.5, 1.1],
              [7.56, 1.16],
            ],
          },
          "Ogou 1": {
            center: [7.15, 1.08],
            zoom: 13,
            bounds: [
              [7.12, 1.05],
              [7.18, 1.11],
            ],
          },
        },
      },
      Amou: {
        center: [7.35, 1.02],
        zoom: 11,
        bounds: [
          [7.2, 0.8],
          [7.5, 1.2],
        ],
        communes: {
          Amlame: {
            center: [7.35, 1.02],
            zoom: 13,
            bounds: [
              [7.32, 0.99],
              [7.38, 1.05],
            ],
          },
        },
      },
      Danyi: {
        center: [7.08, 0.85],
        zoom: 11,
        bounds: [
          [6.9, 0.7],
          [7.3, 1.0],
        ],
        communes: {
          "Danyi 1": {
            center: [7.08, 0.85],
            zoom: 13,
            bounds: [
              [7.05, 0.82],
              [7.11, 0.88],
            ],
          },
        },
      },
      Wawa: {
        center: [7.55, 0.75],
        zoom: 11,
        bounds: [
          [7.3, 0.5],
          [7.8, 1.0],
        ],
        communes: {
          Badou: {
            center: [7.55, 0.75],
            zoom: 13,
            bounds: [
              [7.52, 0.72],
              [7.58, 0.78],
            ],
          },
        },
      },
      Moyen_Mono: {
        center: [7.25, 1.35],
        zoom: 11,
        bounds: [
          [7.1, 1.2],
          [7.4, 1.5],
        ],
        communes: {
          Tohoun: {
            center: [7.25, 1.35],
            zoom: 13,
            bounds: [
              [7.22, 1.32],
              [7.28, 1.38],
            ],
          },
        },
      },
      Haho: {
        center: [6.95, 1.18],
        zoom: 11,
        bounds: [
          [6.8, 1.0],
          [7.1, 1.4],
        ],
        communes: {
          Notsé: {
            center: [6.95, 1.18],
            zoom: 13,
            bounds: [
              [6.92, 1.15],
              [6.98, 1.21],
            ],
          },
        },
      },
    },
  },

  Centrale: {
    center: [8.5, 1.0],
    zoom: 8,
    bounds: [
      [7.8, 0.2],
      [9.2, 1.8],
    ],
    prefectures: {
      Tchaoudjo: {
        center: [8.98, 1.14],
        zoom: 10,
        bounds: [
          [8.7, 0.8],
          [9.3, 1.5],
        ],
        communes: {
          Sokodé: {
            center: [8.98, 1.14],
            zoom: 13,
            bounds: [
              [8.95, 1.11],
              [9.01, 1.17],
            ],
          },
          Blitta: {
            center: [8.32, 1.0],
            zoom: 13,
            bounds: [
              [8.29, 0.97],
              [8.35, 1.03],
            ],
          },
        },
      },
      Sotouboua: {
        center: [8.57, 0.98],
        zoom: 10,
        bounds: [
          [8.3, 0.7],
          [8.8, 1.3],
        ],
        communes: {
          Sotouboua: {
            center: [8.57, 0.98],
            zoom: 13,
            bounds: [
              [8.54, 0.95],
              [8.6, 1.01],
            ],
          },
        },
      },
      Tchamba: {
        center: [9.03, 1.42],
        zoom: 10,
        bounds: [
          [8.8, 1.1],
          [9.3, 1.7],
        ],
        communes: {
          Tchamba: {
            center: [9.03, 1.42],
            zoom: 13,
            bounds: [
              [9.0, 1.39],
              [9.06, 1.45],
            ],
          },
        },
      },
    },
  },

  Kara: {
    center: [9.55, 1.19],
    zoom: 8,
    bounds: [
      [9.0, 0.8],
      [10.2, 1.6],
    ],
    prefectures: {
      Kozah: {
        center: [9.55, 1.19],
        zoom: 10,
        bounds: [
          [9.3, 0.9],
          [9.8, 1.5],
        ],
        communes: {
          Kara: {
            center: [9.55, 1.19],
            zoom: 13,
            bounds: [
              [9.52, 1.16],
              [9.58, 1.22],
            ],
          },
          Pya: {
            center: [9.62, 1.25],
            zoom: 13,
            bounds: [
              [9.59, 1.22],
              [9.65, 1.28],
            ],
          },
        },
      },
      Bassar: {
        center: [9.25, 0.78],
        zoom: 10,
        bounds: [
          [9.0, 0.5],
          [9.5, 1.1],
        ],
        communes: {
          Bassar: {
            center: [9.25, 0.78],
            zoom: 13,
            bounds: [
              [9.22, 0.75],
              [9.28, 0.81],
            ],
          },
        },
      },
      Bimah: {
        center: [9.87, 1.11],
        zoom: 10,
        bounds: [
          [9.6, 0.8],
          [10.1, 1.4],
        ],
        communes: {
          Bafilo: {
            center: [9.87, 1.11],
            zoom: 13,
            bounds: [
              [9.84, 1.08],
              [9.9, 1.14],
            ],
          },
        },
      },
      Kéran: {
        center: [9.65, 1.05],
        zoom: 10,
        bounds: [
          [9.4, 0.8],
          [9.9, 1.3],
        ],
        communes: {
          Kanté: {
            center: [9.65, 1.05],
            zoom: 13,
            bounds: [
              [9.62, 1.02],
              [9.68, 1.08],
            ],
          },
        },
      },
      Doufelgou: {
        center: [9.74, 1.03],
        zoom: 10,
        bounds: [
          [9.5, 0.8],
          [10.0, 1.3],
        ],
        communes: {
          Niamtougou: {
            center: [9.74, 1.03],
            zoom: 13,
            bounds: [
              [9.71, 1.0],
              [9.77, 1.06],
            ],
          },
        },
      },
      Assoli: {
        center: [9.45, 1.35],
        zoom: 10,
        bounds: [
          [9.2, 1.1],
          [9.7, 1.6],
        ],
        communes: {
          Kétao: {
            center: [9.45, 1.35],
            zoom: 13,
            bounds: [
              [9.42, 1.32],
              [9.48, 1.38],
            ],
          },
        },
      },
    },
  },

  Savanes: {
    center: [10.8, 0.2],
    zoom: 8,
    bounds: [
      [10.0, -0.2],
      [11.2, 0.6],
    ],
    prefectures: {
      Tone: {
        center: [10.86, 0.21],
        zoom: 10,
        bounds: [
          [10.6, -0.1],
          [11.1, 0.5],
        ],
        communes: {
          Dapaong: {
            center: [10.86, 0.21],
            zoom: 13,
            bounds: [
              [10.83, 0.18],
              [10.89, 0.24],
            ],
          },
          "Tone 1": {
            center: [10.9, 0.18],
            zoom: 13,
            bounds: [
              [10.87, 0.15],
              [10.93, 0.21],
            ],
          },
        },
      },
      Cinkassé: {
        center: [10.75, 0.05],
        zoom: 10,
        bounds: [
          [10.5, -0.2],
          [11.0, 0.3],
        ],
        communes: {
          Cinkassé: {
            center: [10.75, 0.05],
            zoom: 13,
            bounds: [
              [10.72, 0.02],
              [10.78, 0.08],
            ],
          },
        },
      },
      Tandjouaré: {
        center: [10.78, 0.45],
        zoom: 10,
        bounds: [
          [10.5, 0.2],
          [11.1, 0.7],
        ],
        communes: {
          Tandjouaré: {
            center: [10.78, 0.45],
            zoom: 13,
            bounds: [
              [10.75, 0.42],
              [10.81, 0.48],
            ],
          },
        },
      },
      Oti: {
        center: [10.45, 0.35],
        zoom: 10,
        bounds: [
          [10.2, 0.1],
          [10.7, 0.6],
        ],
        communes: {
          Mango: {
            center: [10.36, 0.47],
            zoom: 13,
            bounds: [
              [10.33, 0.44],
              [10.39, 0.5],
            ],
          },
        },
      },
    },
  },
};

// Fonction utilitaire pour obtenir toutes les régions
export const getRegions = () => {
  return Object.keys(togoTerritories);
};

// Fonction utilitaire pour obtenir les préfectures d'une région
export const getPrefectures = (region) => {
  if (!region || !togoTerritories[region]) return [];
  return Object.keys(togoTerritories[region].prefectures);
};

// Fonction utilitaire pour obtenir les communes d'une préfecture
export const getCommunes = (region, prefecture) => {
  if (
    !region ||
    !prefecture ||
    !togoTerritories[region] ||
    !togoTerritories[region].prefectures[prefecture]
  )
    return [];
  return Object.keys(togoTerritories[region].prefectures[prefecture].communes);
};

// Fonction utilitaire pour obtenir les coordonnées et zoom d'un territoire
export const getTerritoryData = (region, prefecture = null, commune = null) => {
  if (!region || !togoTerritories[region]) return null;

  if (
    commune &&
    prefecture &&
    togoTerritories[region].prefectures[prefecture]?.communes[commune]
  ) {
    return togoTerritories[region].prefectures[prefecture].communes[commune];
  }

  if (prefecture && togoTerritories[region].prefectures[prefecture]) {
    return togoTerritories[region].prefectures[prefecture];
  }

  return togoTerritories[region];
};
